import {
    ChevronLeft as ChevronLeftIcon,
    ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import { Grid, IconButton, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { getDocumentation } from "utils/action/documentation";
import { toServerURL } from "utils/generator";

const initData = [
    {
        title: "",
        content: "",
        photo_url: "",
    },
];

export function HomePageDocumentation() {
    const [carouselIndex, setCarouselIndex] = useState(0);
    const [carouselData, setCarouselData] = useState(initData);

    useEffect(() => {
        const fetchData = async () => {
            const response = await getDocumentation();
            const data = response.data;
            setCarouselData(data.results);
        };
        fetchData();

        // Fungsi untuk menggeser ke item berikutnya setiap beberapa detik
        const interval = setInterval(() => {
            setCarouselIndex(
                (prevIndex) => (prevIndex + 1) % carouselData.length
            );
        }, 5000); // Ganti angka ini dengan durasi yang diinginkan (dalam milidetik)

        return () => clearInterval(interval);
    }, []);

    const goToPrevCarouselSlide = () => {
        setCarouselIndex(
            (prevIndex) =>
                (prevIndex - 1 + carouselData.length) % carouselData.length
        );
    };

    const goToNextCarouselSlide = () => {
        setCarouselIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
    };

    const goToCurrentCarouselSlide = (index) => {
        setCarouselIndex(index);
    };

    return (
        <AnimatePresence mode="wait" initial={false}>
            {/* {carouselData.length > 0 ? ( */}
            <div className="home-page-documentation">
                <div className="home-page-documentation-content">
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <div className="home-page-documentation-section-left">
                                <motion.div // Menggunakan <motion.div> di sini
                                    key={`text-${carouselIndex}`}
                                    alt={`slide-${carouselIndex}`}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                >
                                    <Typography
                                        variant="h5"
                                        component="h5"
                                        className="home-page-documentation-content-title"
                                    >
                                        {carouselData[carouselIndex].title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        component="p"
                                        className="home-page-documentation-content-text"
                                    >
                                        {carouselData[carouselIndex].content}
                                    </Typography>
                                </motion.div>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <div className="home-page-documentation-section-right">
                                <motion.img
                                    key={`img-${carouselIndex}`}
                                    alt={`slide-${carouselIndex}`}
                                    src={toServerURL(
                                        carouselData[carouselIndex].photo_url
                                    )}
                                    width={"500px"}
                                    className="home-page-documentation-content-image"
                                    initial={{ opacity: 0, x: 20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -20 }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="home-page-documentation-carousel">
                <div className="home-page-documentation-carousel-content">
                    <IconButton
                        onClick={goToPrevCarouselSlide}
                        disabled={carouselIndex === 0}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                    <div className="home-page-documentation-carousel-content-slide">
                        {carouselData.map((data, index) => {
                            return (
                                <motion.div
                                    key={`dot-${index}`}
                                    className="home-page-documentation-carousel-content-slide-dot"
                                    style={{
                                        backgroundColor:
                                            index === carouselIndex
                                                ? "red"
                                                : "gray",
                                        width:
                                            index === carouselIndex
                                                ? "24px"
                                                : "8px",
                                        borderRadius:
                                            index === carouselIndex
                                                ? "20px"
                                                : "50px",
                                    }}
                                    whileHover={{ scale: 1.2 }}
                                    onClick={() =>
                                        goToCurrentCarouselSlide(index)
                                    }
                                />
                            );
                        })}
                    </div>
                    <IconButton
                        onClick={goToNextCarouselSlide}
                        disabled={carouselIndex === carouselData.length - 1}
                    >
                        <ChevronRightIcon />
                    </IconButton>
                </div>
            </div>
            {/* ) : (  Tampilkan pesan atau elemen lain jika carouselData1 kosong
       <div>Tidak ada data dokumentasi.</div>
      )} */}
        </AnimatePresence>
    );
}
